import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import {
  useUpdateModuleStatusMutation,
  useBookmarkModuleMutation,
} from "../../store/services/moduleServerApi";

const Module_5_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  const [
    updateModuleStatus,
    {
      isLoading,
      error: { data: { message: errorMessage } = {} } = {},
      data: { message: successMessage } = {},
    },
  ] = useUpdateModuleStatusMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    updateModuleStatus({ moduleNo: 2, end: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="">
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              2.4.11 Module Summary
            </h1>
            <p className="mt-3">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5 row">
            <div className="col-sm-12">
              <h2 className="b text-uppercase mb-3">
                <span className="orange">Congratulations!</span> You have completed Module 2: Learn the Key Anatomy, Steps, and Interpretation Criteria for Amyvid PET images.
              </h2>
              <p>
                Proceed to Module 3: Put Your Knowledge to the Test With Real
                Case Studies, the final module of the required Amyvid Reader
                Training content (Modules 1-3).
              </p>
            </div>
          </section>
          <LdsButton
            classes="blue-button mt-5 mb-5"
            onClick={function navClick() {
              window.open("/overview", "_self");
            }}
          >
            Module Overview
          </LdsButton>
        </main>
      </div>
    </div>
  );
};

export default Module_5_1_1;
